import React from "react";

const VARIANT_STYLES = {
  primary: { background: "#002FA7", color: "white", border: "1px solid #002FA7" },
  danger: { background: "#E11D48", color: "white", border: "1px solid #E11D48" },
  warn: { background: "#F59E0B", color: "white", border: "1px solid #F59E0B" },
  outline: { background: "white", color: "#0F172A", border: "1px solid #E2E8F0" },
};

export function Action({ icon: Icon, label, onClick, disabled, variant = "primary", testid }) {
  return (
    <button data-testid={testid} onClick={onClick} disabled={disabled}
      style={VARIANT_STYLES[variant]}
      className="h-10 px-4 text-sm font-medium rounded-md inline-flex items-center gap-2 disabled:opacity-50 transition-colors hover:opacity-90">
      <Icon size={14} weight="bold" /> {label}
    </button>
  );
}
